import type { Author, AuthorProgram } from '../../interface/Author';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getAuthorPrograms = async (
  url: string,
  { page, type }: Omit<GetAuthorProgramsParams, 'id'>
) => {
  const { data } = await api.get<{ data: AuthorProgram[] }>(url, {
    params: { page, type },
  });

  return data.data;
};

export const useGetAuthorPrograms = ({
  id,
  page,
  type,
}: GetAuthorProgramsParams) => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.author.programs(id)
      : apiConfig.routes.author.publicPrograms(id);

  return useQuery({
    queryKey: ['entertainment', 'author', id, 'programs', url, { page, type }],
    queryFn: () => getAuthorPrograms(url, { page, type }),
  });
};

type GetAuthorProgramsParams = {
  id: Author['id'];
  page?: number;
  type?: string;
};
